import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import mixpanel from 'mixpanel-browser';
import { useAuth } from '@/lib/auth';

export function PageViewTracker() {
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    // Track page view in Mixpanel (only if Mixpanel is initialized)
    // Mixpanel SDK is loaded asynchronously, so check if it's available
    const trackPageView = () => {
      if (typeof window.mixpanel !== 'undefined' && window.mixpanel.track) {
        try {
          mixpanel.track('Page View', {
            page_url: window.location.href,
            page_title: document.title,
            user_id: user?.id || null,
          });
        } catch (error) {
          // Silently fail if Mixpanel tracking fails
          console.debug('Mixpanel page view tracking failed:', error);
        }
      } else {
        // Retry after a short delay if Mixpanel SDK hasn't loaded yet
        setTimeout(trackPageView, 100);
      }
    };
    
    // Start tracking after a small delay to ensure Mixpanel is initialized
    setTimeout(trackPageView, 100);
  }, [location.pathname, user?.id]);

  return null;
}
